import {
  IcnBookOpen,
  IcnBookmark,
  IcnCalendar,
  IcnCheck,
  IcnComment,
  IcnDoc,
  IcnFolder,
  IcnGlobe,
  IcnMail,
  IcnPencil,
  IcnPin,
  IcnTag,
  IcnUser,
} from '@viquard/doc-ui';
import type { ReactElement } from 'react';
import type { SearchHit } from '../api.js';

export const SEARCH_HIT_SCOPES = [
  'articles',
  'files',
  'folders',
  'groups',
  'members',
  'forum',
  'comments',
  'annotations',
  'surveys',
  'calendar',
  'scheduling',
  'coordination',
  'bookmarks',
  'newsletters',
  'taxonomy',
] as const satisfies readonly SearchHit['scope'][];

export type SearchHitScope = SearchHit['scope'];

export function iconForScope(scope: SearchHitScope): ReactElement {
  switch (scope) {
    case 'articles':
      return <IcnBookOpen size={16} />;
    case 'files':
      return <IcnDoc size={16} />;
    case 'folders':
      return <IcnFolder size={16} />;
    case 'groups':
      return <IcnGlobe size={16} />;
    case 'members':
      return <IcnUser size={16} />;
    case 'forum':
      return <IcnComment size={16} />;
    case 'comments':
      return <IcnComment size={16} />;
    case 'annotations':
      return <IcnPencil size={16} />;
    case 'surveys':
      return <IcnDoc size={16} />;
    case 'calendar':
      return <IcnCalendar size={16} />;
    case 'scheduling':
      return <IcnPin size={16} />;
    case 'coordination':
      return <IcnCheck size={16} />;
    case 'bookmarks':
      return <IcnBookmark size={16} />;
    case 'newsletters':
      return <IcnMail size={16} />;
    case 'taxonomy':
      return <IcnTag size={16} />;
  }
}
